import { TypeMaintenanceSchedulingEnums } from "src/app/enum/maintenance-scheduling.enums";

export class MaintenanceSchedulingModel {
    maintenanceSchedulingId: number = 0;
    branchId: number = 0;
    consecutive: number = 0;
    typeMaintenanceScheduling: number = TypeMaintenanceSchedulingEnums.horometro;
    dateMaintenanceScheduling: Date = new Date();
    observation: string | null = null;
    active: boolean = false;
    createDate: Date = new Date();
    userNameCreate: string = '';
    updateDate: Date | null = null;
    userNameUpdate: string | null = null;
}
